import React, { useState } from 'react';
import { playThemeSound } from '../../../utils/themeAudio';

const BULB_COLORS = [
    { color: '#ef4444', filter: 'drop-shadow(0 0 10px rgba(239, 68, 68, 0.9))' },
    { color: '#22c55e', filter: 'drop-shadow(0 0 10px rgba(34, 197, 94, 0.9))' },
    { color: '#fbbf24', filter: 'drop-shadow(0 0 10px rgba(251, 191, 36, 0.9))' },
    { color: '#38bdf8', filter: 'drop-shadow(0 0 10px rgba(56, 189, 248, 0.9))' },
];

const InteractiveFairyLights = () => {
    const [sparkleIndex, setSparkleIndex] = useState(null);

    const handleBulbTouch = (idx) => {
        setSparkleIndex(idx);
        playThemeSound('christmas', 'jingle');
        setTimeout(() => setSparkleIndex(null), 800);
    };

    return (
        <div className="sticky top-0 mt-[55px] md:mt-[75px] mb-[-120px] md:mb-[-170px] left-0 right-0 h-16 md:h-24 pointer-events-none z-[62] overflow-hidden select-none">
            <div className="w-full h-full relative">
                <svg viewBox="0 0 1200 60" preserveAspectRatio="none" className="w-full h-full overflow-visible">
                    {/* Dark Green Garland Wire with double arch */}
                    <path
                        d="M0 0 Q 300 70 600 0 Q 900 70 1200 0"
                        fill="none"
                        stroke="#14532d"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                    />

                    {/* 24 Interactive Christmas Bulbs */}
                    {Array.from({ length: 24 }).map((_, i) => {
                        const scheme = BULB_COLORS[i % BULB_COLORS.length];
                        const x = i * (1200 / 23);
                        const normalizedX = x % 600;
                        const t = normalizedX / 600;
                        const curveY = 2 * (1 - t) * t * 70;
                        const isSparkled = sparkleIndex === i;

                        return (
                            <g
                                key={i}
                                transform={`translate(${x}, ${curveY})`}
                                className="pointer-events-auto cursor-pointer group"
                                onMouseEnter={() => handleBulbTouch(i)}
                                onClick={() => handleBulbTouch(i)}
                                onTouchStart={() => handleBulbTouch(i)}
                            >
                                {/* Socket */}
                                <rect x="-3" y="-3" width="6" height="7" fill="#1f2937" rx="1.5" />

                                {/* Glass Bulb */}
                                <path
                                    d="M0 4 C -5 4 -5 16 0 16 C 5 16 5 4 0 4"
                                    fill={scheme.color}
                                    style={{
                                        filter: isSparkled
                                            ? `drop-shadow(0 0 20px ${scheme.color})`
                                            : scheme.filter,
                                        transform: isSparkled ? 'scale(1.4)' : 'scale(1)',
                                        transformOrigin: '0 8px',
                                        transition: 'transform 0.2s ease, filter 0.2s ease',
                                    }}
                                    className={!isSparkled ? 'animate-pulse' : ''}
                                />

                                {/* Reflection Highlight */}
                                <circle cx="-1.5" cy="8" r="1.5" fill="#ffffff" opacity={isSparkled ? 0.9 : 0.4} />

                                {/* Interactive Sparkle Indicator */}
                                {isSparkled && (
                                    <text x="0" y="-8" textAnchor="middle" fontSize="12" fill="#fef08a" className="animate-bounce font-bold">
                                        ✨
                                    </text>
                                )}
                            </g>
                        );
                    })}
                </svg>
            </div>
        </div>
    );
};

export default InteractiveFairyLights;
